import styled from "styled-components";
import { Typography } from "../../../../../components";
import { device } from "../../../../../style";

export const ProfitBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ProfitWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1px;
  justify-content: flex-start;
  align-items: flex-end;

  @media ${device.tablet} {
    flex-direction: row;
    align-items: center;
    gap: 2px;
  }
`;

export const Profit = styled(Typography.Description)<{ success: boolean }>`
  background-color: ${({ theme, success }) =>
    success ? theme.colors.walletStatus.backgroundOn : theme.colors.errorDark};
  color: ${({ theme, success }) =>
    success ? theme.colors.success : theme.colors.error};
  padding: 4px;
  border-radius: 4px;
  align-self: flex-start;
`;
